







































































































import { Vue, Component, Prop } from "vue-property-decorator";
import CustomTableCol from "../form/CustomTableCol.vue";
import CustomTableItem from "../form/CustomTableItem.vue";
import CustomTable from "../form/CustomTable.vue";
import { User as IUser } from "@/api/models/user";
import companyList, { CompanyListParams } from "@/getinfo-api/company";
import {
  CompaniesList as ICompaniesList,
  Company as ICompany
} from "@/api/models";
import EditDiskForm from "@/components/admin/EditDiskForm.vue";
import { consentModule } from "@/plugins/modules-detect";

@Component({
  components: { EditDiskForm, CustomTableCol, CustomTableItem, CustomTable }
})
export default class UsersListFormItem extends Vue {
  @Prop() item!: IUser;
  @Prop() index!: number;
  @Prop({ default: false }) isAdminFunctional!: boolean;
  usersCompanies: Array<ICompany> = [];
  isGettingResult: boolean = false;
  uniqId: string = this.isConsentModuleEnabled
    ? "id" +
      Math.random()
        .toString(16)
        .slice(2)
    : "";

  get isConsentModuleEnabled() {
    return consentModule();
  }

  get consentUserInfo() {
    return {
      isShow: this.isConsentModuleEnabled && this.item?.consent,
      value: this.item?.consent
        ? this.$converter.date(this.item.consentAt!)
        : this.$tc(this.$translate.DidNotAgree)
    };
  }

  created() {
    let params: CompanyListParams = {
      employeesIds: [this.item.id],
      limit: 999
    };
    this.isGettingResult = true;
    companyList(params)
      .then((res: { data: ICompaniesList }) => {
        this.usersCompanies = res.data.companies;
      })
      .finally(() => {
        this.isGettingResult = false;
      });
  }
}
